/* MÚSICA DE CULTO — comportamiento (solo layout/musica.liquid). Sin dependencias. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const conn = navigator.connection;
  const lightData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));

  /* Cabecera: toma el color de la sección que tiene debajo
     (foto → texto del artista sin fondo; sección sólida → fondo sólido). */
  const header = document.querySelector('.mdc-header');
  const bar = header && header.querySelector('.mdc-header__bar');
  if (bar && document.elementsFromPoint) {
    header.classList.add('mdc-header--tone');
    const body = document.body;
    const isCollection = body.classList.contains('mdc--collection');
    let ticking = false;
    let last = null;
    const update = () => {
      ticking = false;
      const y = bar.offsetHeight / 2;
      const hits = document.elementsFromPoint(window.innerWidth / 2, y);
      let el = null;
      for (const h of hits) {
        if (header.contains(h)) continue;
        el = h.closest('[data-mdc-tone]');
        if (el) break;
      }
      const target = el || body;
      if (target !== last) {
        last = target;
        const cs = getComputedStyle(target);
        const fg = cs.getPropertyValue('--mdc-fg').trim();
        const bg = cs.getPropertyValue('--mdc-bg').trim();
        const fgRgb = cs.getPropertyValue('--mdc-fg-rgb').trim();
        const solid = !el || el.dataset.mdcTone === 'solid' || body.classList.contains('mdc--offset');
        header.style.setProperty('--mdc-header-fg', fg);
        if (fgRgb) header.style.setProperty('--mdc-header-fg-rgb', fgRgb);
        header.style.setProperty('--mdc-header-bg', solid ? bg : 'transparent');
      }
      if (isCollection) {
        document.documentElement.classList.toggle('mdc-past-hero', window.scrollY > window.innerHeight * 0.85);
      }
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* Entrada de cada artista al aparecer en pantalla */
  const revealables = document.querySelectorAll('[data-mdc-reveal]');
  if (revealables.length && 'IntersectionObserver' in window && !reduceMotion) {
    document.documentElement.classList.add('mdc-reveal-ready');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );
    revealables.forEach((el) => io.observe(el));
  }

  /* Video de fondo: solo se descarga y reproduce si está en pantalla
     y la conexión lo permite. Mientras tanto se ve la foto. */
  if (!customElements.get('mdc-video')) {
    customElements.define(
      'mdc-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video || reduceMotion || lightData) return;
          this.video.muted = true;
          this.video.playsInline = true;
          this.video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                if (this.video.preload === 'none') this.video.preload = 'auto';
                const p = this.video.play();
                if (p && p.catch) p.catch(() => {});
              } else {
                this.video.pause();
              }
            },
            { threshold: 0.15 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  /* Tallas: un toque agrega al carrito usando el carrito de Dawn
     (notificación o cajón), igual que el botón de la página de producto. */
  if (!customElements.get('mdc-quick-add')) {
    customElements.define(
      'mdc-quick-add',
      class extends HTMLElement {
        connectedCallback() {
          this.message = this.querySelector('.mdc-sizes__msg');
          this.addEventListener('click', this.onClick.bind(this));
        }

        setMessage(text) {
          if (this.message) this.message.textContent = text;
        }

        async onClick(event) {
          const button = event.target.closest('button[data-variant-id]');
          if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const body = new FormData();
          body.append('id', button.dataset.variantId);
          body.append('quantity', '1');
          if (cart && typeof cart.getSectionsToRender === 'function') {
            body.append(
              'sections',
              cart.getSectionsToRender().map((section) => section.id)
            );
            body.append('sections_url', window.location.pathname);
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
          }

          button.setAttribute('aria-busy', 'true');
          this.setMessage('Agregando…');

          try {
            const response = await fetch(window.routes.cart_add_url, {
              method: 'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body,
            });
            const data = await response.json();

            if (data.status) {
              this.setMessage(data.description || data.message || 'No se pudo agregar');
              return;
            }

            button.classList.add('is-added');
            this.setMessage('Agregado ✓');

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'mdc-quick-add',
                productVariantId: button.dataset.variantId,
                cartData: data,
              });
            }

            if (cart && typeof cart.renderContents === 'function') {
              cart.classList.remove('is-empty');
              cart.renderContents(data);
            } else {
              window.location = window.routes.cart_url;
              return;
            }

            setTimeout(() => {
              button.classList.remove('is-added');
              this.setMessage('');
            }, 2600);
          } catch (error) {
            console.error(error);
            this.setMessage('Error de conexión. Intenta de nuevo.');
          } finally {
            button.removeAttribute('aria-busy');
          }
        }
      }
    );
  }
  /* Carrito vacío: "Seguir comprando" cierra el panel en vez de ir a los productos de Fútbol */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('cart-drawer .drawer__inner-empty a.button');
    if (!link) return;
    event.preventDefault();
    const drawer = link.closest('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
  });

  /* Músicos de culto: al pasar por un nombre del setlist se ve su ilustración */
  document.querySelectorAll('.mdc-mus__setlist').forEach((setlist) => {
    const img = setlist.querySelector('.mdc-mus__peek img');
    const songs = setlist.querySelectorAll('.mdc-mus__song[data-art]');
    if (!img || !songs.length) return;
    const show = (song) => {
      const src = song.dataset.art;
      if (img.getAttribute('src') === src) return;
      img.hidden = false;
      img.src = src;
      img.style.animation = 'none';
      void img.offsetWidth;
      img.style.animation = '';
    };
    show(songs[0]);
    songs.forEach((song) => {
      song.addEventListener('mouseenter', () => show(song));
      song.addEventListener('focus', () => show(song));
    });
  });

  /* Músicos de culto: un músico con varias poleras muestra sus versiones en la misma lámina */
  const activateVersion = (plate, v) => {
    if (!plate) return;
    const val = String(v);
    plate.querySelectorAll('.mdc-plate__art[data-v], .mdc-plate__info[data-v]').forEach((el) => {
      el.classList.toggle('is-off', el.dataset.v !== val);
    });
    plate.querySelectorAll('.mdc-vers__btn').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.v === val)));
  };
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.mdc-vers__btn');
    if (!btn) return;
    const plate = btn.closest('.mdc-plate');
    activateVersion(plate, btn.dataset.v);
    const twin = plate.querySelector(`.mdc-plate__info[data-v="${btn.dataset.v}"] .mdc-vers__btn[data-v="${btn.dataset.v}"]`);
    if (twin) twin.focus({ preventScroll: true });
  });
  const versionFromHash = () => {
    const id = decodeURIComponent(location.hash.slice(1));
    if (!id) return;
    const el = document.getElementById(id);
    if (!el || !el.classList.contains('mdc-plate__anchor')) return;
    const plate = el.closest('.mdc-plate');
    activateVersion(plate, el.closest('[data-v]').dataset.v);
    plate.scrollIntoView();
  };
  versionFromHash();
  window.addEventListener('hashchange', versionFromHash);

  /* Carrusel de "más músicos": flechas en computador */
  document.querySelectorAll('[data-mdc-rail]').forEach((btn) => {
    const rail = btn.closest('section') && btn.closest('section').querySelector('.mdc-mus__rail');
    if (!rail) return;
    const dir = Number(btn.dataset.mdcRail);
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth - 2;
      btn.disabled = dir < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max;
    };
    btn.addEventListener('click', () => rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' }));
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  });

  /* Músicos de culto: buscador (filtra el setlist y las láminas) */
  document.querySelectorAll('[data-mdc-find]').forEach((nav) => {
    const input = nav.querySelector('.mdc-find__input');
    if (!input) return;
    const clear = nav.querySelector('.mdc-find__clear');
    const count = nav.querySelector('.mdc-find__count');
    const empty = nav.querySelector('.mdc-find__empty');
    const wa = empty && empty.querySelector('a[data-wa-base]');
    const norm = (s) =>
      (s || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    const rows = [...nav.querySelectorAll('li[data-mdc-q]')].map((el) => ({ el, k: norm(el.dataset.mdcQ) }));
    const plates = [...document.querySelectorAll('.mdc-plate[data-mdc-q]')].map((el) => ({ el, k: norm(el.dataset.mdcQ) }));
    const total = rows.length;
    let first = null;
    const run = () => {
      const terms = norm(input.value).split(' ').filter(Boolean);
      const match = (k) => terms.every((t) => (' ' + k).includes(' ' + t) || k.includes(t));
      let shown = 0;
      first = null;
      rows.forEach((r) => {
        const ok = !terms.length || match(r.k);
        r.el.hidden = !ok;
        if (ok) {
          shown += 1;
          if (!first) first = r.el.querySelector('a');
        }
      });
      plates.forEach((p) => {
        p.el.hidden = terms.length > 0 && !match(p.k);
      });
      if (count) count.textContent = terms.length ? `${shown} de ${total}` : `${total} músicos`;
      if (empty) empty.hidden = !terms.length || shown > 0;
      nav.classList.toggle('is-empty', shown === 0);
      if (first && terms.length) first.dispatchEvent(new Event('mouseenter'));
      if (wa) wa.href = wa.dataset.waBase + encodeURIComponent(input.value.trim());
      if (clear) clear.hidden = !input.value;
    };
    input.addEventListener('input', () => {
      run();
      /* que los resultados queden justo debajo del buscador */
      if (nav.getBoundingClientRect().top < 0) nav.scrollIntoView({ block: 'start' });
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && first) {
        event.preventDefault();
        first.click();
      }
      if (event.key === 'Escape' && input.value) {
        input.value = '';
        run();
      }
    });
    if (clear)
      clear.addEventListener('click', () => {
        input.value = '';
        run();
        input.focus();
      });
    run();
  });
})();
